import { getApiToken } from 'api/apiRequest';
import { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { slugify } from 'utils/global';
import * as StoryApi from 'api/Story';
import { StoryApiResponse } from 'api/api.types';
import StoryPage from 'src/page-components/story/StoryPage';
import HeadMetadata from 'src/components/metadata/HeadMetadata';
import { getStoryPageMetadata } from 'utils/metadata.utils';
import { Analytics, Events } from 'services/analytics';

interface InitialProps {
  story: StoryApiResponse;
}

const StoryDynamicPage: NextPage<InitialProps> = ({ story }) => {
  React.useEffect(() => {
    Analytics.logEvent({
      eventName: Events.story.viewStoryPage,
      properties: {
        storyId: story.id,
        storyTitle: story.title,
      },
      platforms: ['amplitude'],
    });
  }, []);

  return (
    <>
      <HeadMetadata pageMetadata={getStoryPageMetadata({ story: story })} />
      <StoryPage story={story} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<InitialProps> = async ({
  params,
  req,
}) => {
  if (!params) return { notFound: true };

  const token = getApiToken({ requestServer: req, allowDefault: true });

  const id = Number(params.id);

  const story = await StoryApi.getStory({ id, token }).catch(_ => undefined);

  if (!story) {
    return { notFound: true };
  }

  const slug = slugify(story.title);

  if (params.slug !== slug) {
    //Redirect to the correct slug
    return {
      redirect: {
        destination: `/story/${id}/${slug}`,
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      story,
    },
  };
};

export default StoryDynamicPage;
